import OperationalPaymentsView from '../OperationalPaymentsView.vue'
import OperationalPaymentList from '../Pages/OperationalPaymentList.vue'
import OperationalPaymentDetail from '../Pages/OperationalPaymentDetail.vue'

const routes = [
  {
    path: '/pagos-operativos',
    component: OperationalPaymentsView,
    children: [
      { path: '', name: 'operational-payment-list', component: OperationalPaymentList },
      { path: ':id', name: 'operational-payment-detail', component: OperationalPaymentDetail },
    ],
  },
]

export default routes
